import { Shield, Clock, HeartHandshake, Award, Stethoscope, MapPin } from "lucide-react";

const pillars = [
  { icon: Stethoscope, title: "10+ Years Expertise", desc: "Over a decade of hands-on surgical experience across complex procedures." },
  { icon: Shield, title: "Advanced Technology", desc: "State-of-the-art laparoscopic and laser equipment for precision surgery." },
  { icon: HeartHandshake, title: "Patient-First Care", desc: "Every treatment plan is personalized to ensure the best outcomes for you." },
  { icon: Clock, title: "Quick Recovery", desc: "Minimally invasive techniques mean faster healing and shorter hospital stays." },
  { icon: Award, title: "Proven Track Record", desc: "5000+ successful surgeries with consistently high patient satisfaction." },
  { icon: MapPin, title: "2 Convenient Locations", desc: "Easily accessible clinics in Vijayawada — Kanuru and Penamaluru." },
];

export default function WhyChoose() {
  return (
    <section data-testid="why-choose-section" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <p className="reveal text-teal font-medium text-sm uppercase tracking-widest mb-3">Why Choose Us</p>
          <h2 className="reveal delay-1 font-heading font-bold text-3xl md:text-4xl text-navy tracking-tight">Why Choose Dr. Dileep Sunkavalli</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {pillars.map((p, i) => (
            <div key={p.title} data-testid={`pillar-${i}`} className={`reveal delay-${Math.min(i + 1, 4)} flex gap-4 items-start p-5 rounded-xl border border-slate-50 hover:border-teal/20 hover:bg-teal-light/30 transition-all duration-300`}>
              <div className="w-12 h-12 rounded-xl bg-teal/10 flex items-center justify-center flex-shrink-0"><p.icon className="w-6 h-6 text-teal" strokeWidth={1.5} /></div>
              <div><h3 className="font-heading font-semibold text-navy text-base mb-1">{p.title}</h3><p className="text-sm text-slate-500 leading-relaxed">{p.desc}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
